module.exports = __webpack_public_path__ + "img/mark-dark.b1301bb4.svg";